import React, { useEffect, useState } from "react";
import { getJogadores } from "../../../db/db";
import "./DashboardEstatisticas.css";

const DashboardEstatisticas = ({ refreshToken = 0 }) => {
  const [todosJogadores, setTodosJogadores] = useState([]);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const dadosJogadores = await getJogadores();

        if (dadosJogadores.length > 0) {
          setTodosJogadores(dadosJogadores);
        } else {
          console.log("Nenhum jogo encontrado.");
        }
      } catch (error) {
        console.error("Erro ao recuperar os dados iniciais:", error);
      }
    };
    fetchInitialData();
  }, [refreshToken]);

  // Função para calcular os pontos dos jogadores
  const calcularPontos = (jogador) =>
    jogador.gols * 2 +
    jogador.assistencias * 1 +
    jogador.vitorias * 3 +
    jogador.empates * 1;

  // Ordena os jogadores com base nos pontos
  const ranking = todosJogadores
    .map((jogador) => {
      const partidas = jogador.qt_partidas || 0;
      const desempenhoTotal = jogador.desempenhoAcumulado || 0;
      const desempenhoMedio =
        partidas > 0
          ? Number((desempenhoTotal / partidas).toFixed(3))
          : 0;
      const overallGlobal =
        typeof jogador.overallGlobal === "number" ? jogador.overallGlobal : 65;
      const overallTurma =
        typeof jogador.overallTurma === "number"
          ? jogador.overallTurma
          : overallGlobal;

      return {
        ...jogador,
        pontos: calcularPontos(jogador),
        desempenhoMedio,
        overallExibicao: Number.isFinite(overallTurma) ? overallTurma : overallGlobal,
      };
    })
    .sort((a, b) => b.pontos - a.pontos);

  return (
    <>
      <label className="label-app">| Estatísticas Individuais</label>

      <div className="aba-conteudo">
        <table className="ranking-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Nome</th>
              <th>V</th>
              <th>E</th>
              <th>Gols</th>
              <th>Ass</th>
              <th>Pts</th>
              {/* <th>Des.</th>
              <th>OVR</th> */}
            </tr>
          </thead>
          <tbody>
            {ranking.map((jogador, index) => (
              <tr key={jogador.id}>
                <td>{index + 1}</td>
                <td>{jogador.nome}</td>
                <td>{jogador.vitorias}</td>
                <td>{jogador.empates}</td>
                <td>{jogador.gols}</td>
                <td>{jogador.assistencias}</td>
                <td>{jogador.pontos}</td>
                {/* <td>{jogador.desempenhoMedio.toFixed(2)}</td>
                <td>{Number(jogador.overallExibicao || 65).toFixed(1)}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default DashboardEstatisticas;
